// extracted by mini-css-extract-plugin
module.exports = {"checked":"Settings_checked__14Lfk"};